import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["aria-selected", "onClick"]

import { ref, computed, watch, toRefs } from "vue";

import { useToDoStore } from "@/stores/ToDoStore";
import { nextTick } from "process";
import { useGlobalStore } from "@/stores/GlobalStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'TodoDatalistInput',
  props: {
    datalist: {}
  },
  emits: ["addTodo"],
  setup(__props: any, { emit: __emit }) {

const globalStore = useGlobalStore();

const todoStore = useToDoStore();
const { todoText } = toRefs(todoStore);

const props = __props;
const $emits = __emit;

const computedDataList = computed(() => {
  return matchedOptions();
});
const matchedOptions = () => {
  const trimmedTodoText = todoText.value.toLowerCase().trim();

  return props.datalist.filter((option) => {
    const optionLowerCase = option.toLowerCase();

    // Skip exact matches
    if (optionLowerCase === trimmedTodoText) {
      return false;
    }

    // Return options that partially match
    return optionLowerCase.includes(trimmedTodoText);
  });
};

const datalistOptionsRef = ref<Record<number, HTMLLIElement> | null>(null);

const pickedDlistIndex = ref<number | null>(null);

/// <---
const handleKeydown = (e: KeyboardEvent) => {
  const { key } = e;
  const optionsLength = computedDataList.value.length;

  if (key === "ArrowDown" || key === "ArrowUp") {
    if (!optionsLength) return;
    const direction = key === "ArrowDown" ? 1 : -1;

    if (pickedDlistIndex.value === null) {
      pickedDlistIndex.value = key === "ArrowDown" ? 0 : optionsLength - 1;
    } else {
      pickedDlistIndex.value = (pickedDlistIndex.value + direction + optionsLength) % optionsLength;
    }

    const selectedOption = datalistOptionsRef.value?.[pickedDlistIndex.value];
    selectedOption?.scrollIntoView({ block: "nearest" });
  } else if (key === "Control" && !isDatalistOpen.value) {
    isDatalistOpen.value = true;
    pickedDlistIndex.value = null;
  } else if (key === "Escape") {
    if (pickedDlistIndex.value === null && isDatalistOpen.value === false) {
      todoInputRef.value?.blur();
    } else {
      isDatalistOpen.value = false;
      pickedDlistIndex.value = null;
    }
  } else if (key === "Enter") {
    if (pickedDlistIndex.value !== null) {
      putDatalistOptionValueToTheTodoText();
    } else {
      $emits("addTodo", todoText);
    }
  }
};
// handleKeydown's last option. Important! Do not separate the watcher further away
watch(computedDataList, () => {
  pickedDlistIndex.value = null;
});
// --->

const handleOptionClick = (index: number) => {
  console.log(index, computedDataList.value[index]);
  todoText.value = computedDataList.value[index];

  setTimeoutId.value && clearTimeout(setTimeoutId.value);
  nextTick(() => {
    todoInputRef.value?.focus();
    isDatalistOpen.value = true;
  });
};

const putDatalistOptionValueToTheTodoText = () => {
  if (pickedDlistIndex.value !== null) {
    todoText.value = computedDataList.value[pickedDlistIndex.value];
  } else console.error(`pickedDlistIndex.value !== null; when calling this function you can't have pickedDListIndex.value to have null`);
};
const isDatalistOpen = ref(false);
const todoInputRef = ref<HTMLInputElement | null>(null);
const setTimeoutId = ref<ReturnType<typeof setTimeout> | null>(null);
const handleBlur = () => {
  setTimeoutId.value = setTimeout(() => {
    isDatalistOpen.value = false;
  }, 140);
};

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      role: "combobox",
      list: "datalist-suggestions",
      class: "w-full sm:px-4 pr-3 pl-2 py-2 rounded bg-inherit text-inherit",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(todoText) ? (todoText).value = $event : null)),
      "aria-label": "Add a new task",
      placeholder: "Add a new task",
      type: "text",
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (isDatalistOpen.value = true)),
      onBlur: handleBlur,
      ref_key: "todoInputRef",
      ref: todoInputRef,
      onKeydown: handleKeydown
    }, null, 544), [
      [_vModelText, _unref(todoText)]
    ]),
    (isDatalistOpen.value && computedDataList.value.length)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass([_unref(globalStore).bgThemeClass, "absolute top-14 py-2 px-1 rounded-2xl flex flex-col custom-shadow max-h-52 overflow-auto md:scrollbar-thin md:scrollbar-thumb-gray-500 md:scrollbar-track-gray-100"]),
          "aria-label": "datalist",
          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["down"]))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedDataList.value, (option, index) => {
            return (_openBlock(), _createElementBlock("li", {
              ref_for: true,
              ref_key: "datalistOptionsRef",
              ref: datalistOptionsRef,
              role: "option",
              onClick: [
                _cache[2] || (_cache[2] = () => {}),
                ($event: any) => (handleOptionClick(index))
              ],
              class: _normalizeClass(["px-2 rounded cursor-pointer hover:outline hover:outline-orange-400 hover:outline-1", index === pickedDlistIndex.value ? 'outline outline-orange-400 outline-1' : '']),
              "aria-selected": index === pickedDlistIndex.value,
              "aria-live": "assertive"
            }, _toDisplayString(option), 11, _hoisted_2))
          }), 256))
        ], 34))
      : _createCommentVNode("", true)
  ])), [
    [_directive_auto_animate, { duration: 150 }]
  ])
}
}

})